import { createFileRoute, stripSearchParams } from "@tanstack/react-router";
import { PROJECT } from "@/app/capabilities/permissions";
import { GatewayCreatePage } from "@/app/mcp-gateways/create-page/gateway-create-page";
import {
  mcpGatewayNewSearchDefaults,
  mcpGatewayNewSearchSchema,
} from "@/app/mcp-gateways/search-params";
import { toolkitCollectionQueryOptions } from "@/app/tools/api/get-toolkit-collection";
import { requireProjectPermission } from "@/lib/route-guards";

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/mcp-gateways/new"
)({
  validateSearch: mcpGatewayNewSearchSchema,
  search: {
    middlewares: [stripSearchParams(mcpGatewayNewSearchDefaults)],
  },
  async beforeLoad(ctx) {
    await requireProjectPermission(ctx, PROJECT.mcpGateways.create);

    const catalog = toolkitCollectionQueryOptions({
      organizationId: ctx.params.organizationId,
      projectId: ctx.params.projectId,
    });
    if (ctx.search.tools.length > 0) {
      // Prefilled `?tools=` must be reconciled against the catalog (canonical
      // casing, version stripping, dropping unknowns) before a submit can fire.
      // Block until the catalog is present so the picker mounts resolved rather
      // than mid-load, closing the window where a fast submit sends raw names.
      await ctx.context.queryClient.ensureQueryData(catalog);
    } else {
      // No prefill, nothing to reconcile pre-submit — just warm the cache so the
      // picker fills in without a skeleton flash while the form stays usable.
      ctx.context.queryClient.prefetchQuery(catalog);
    }
  },
  component: RouteComponent,
  loader: () => ({ crumb: "New gateway" }),
});

function RouteComponent() {
  const { tools } = Route.useSearch();

  return <GatewayCreatePage initialTools={tools} />;
}
